import React, { useState, useEffect, Component } from "react";
import moment from "moment/moment";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import LeaseApiService from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import { ClipLoader } from 'react-spinners';
import { FaSave } from "react-icons/fa";
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import { MdDelete } from "react-icons/md";
import WindowedSelect from 'react-windowed-select';
import { useNavigate } from 'react-router-dom';
import { getName } from '../../../Redux/selecters';
import { useSelector } from "react-redux";

const LeaseBalancePayment = () => {
    const apiService = new LeaseApiService();
    const [rowData, setRowData] = useState([]);
    const [loading, setLoader] = useState(false);
    const [FilterTab, setFilterTab] = useState(true);
    const [leaseList, setLeaseList] = useState([]);
    const [accountList, setAccountList] = useState([]);
    const [debitList, setDebitList] = useState([]);
    const [currencyList, setCurrencyList] = useState([]);
    const [propertyType, setPropertyType] = useState([]);
    const [blncclr, setblncClr] = useState("text-danger");
    const { currencyPrecision } = useCurrency();
    const total = rowData.reduce((sum, row) => sum + (parseFloat(row?.debit) || 0), 0)
    const userName = useSelector(getName);
    let navigate = useNavigate();

    const [formData, setFormData] = useState({
        leaseNo: "",
        voucherNo: "",
        propertyNo: "",
        property: '',
        unitNo: "",
        voucherDate: "",
        balance: 0,
        refNo: "",
        propertyType: "",
        amount: 0,
        chequeNo: "",
        tenantName: "",
        tenantNo: "",
        accountCr: "",
        chequeDate: "",
        currency: "",
        conversionRate: "",
        paidTo: "",
        fxAmount: 0,
        narration: "",
        amountCr: "",
    })

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };

    useEffect(() => {
        fetchDropdownData()
        const today = new Date();
        let todate = formatDate(today)
        setFormData((prev) => ({ ...prev, voucherDate: todate, chequeDate: todate }));
    }, []);

    const fetchDropdownData = async () => {
        try {
            let body = {
                "take": 100,
                "skip": 0,
                "sortColumn": "id",
                "sortDirection": 1
            }
            const currRes = await apiService.post("GET_CURRENCY_PER", body);
            console.log("API Currency Response:", currRes?.data); // DEBUG
            let data = currRes?.data?.data?.items
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LBRCreditAccounts,LBRDebitAccounts,LBRLeaseNumbers,LBRPaymentTypes,LBRCurrency');
            const res = await apiService.getApiParamater('MULTI_BLNC_REF', `?${params.toString()}`);
            setLeaseList(res?.data?.dropdowns?.LBRLeaseNumbers)
            setAccountList(res?.data?.dropdowns?.LBRCreditAccounts)
            setPropertyType(res?.data?.dropdowns?.LBRPaymentTypes)
            setDebitList(res?.data?.dropdowns?.LBRDebitAccounts)
            setCurrencyList(data)
            let defaultCurrency = data?.find((comp) => comp.isDefault === true)
            setFormData(prev => ({ ...prev, currency: { label: defaultCurrency?.code, value: defaultCurrency }, conversionRate: defaultCurrency?.conversionRate }));

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handleClearFilters = () => {
        const today = new Date();
        let todate = formatDate(today)
        setFormData({
            leaseNo: "",
            voucherNo: "",
            propertyNo: "",
            property: '',
            unitNo: "",
            voucherDate: todate,
            balance: 0,
            refNo: "",
            propertyType: "",
            amount: 0,
            chequeNo: "",
            tenantName: "",
            accountCr: "",
            chequeDate: todate,
            currency: "",
            conversionRate: "",
            paidTo: "",
            fxAmount: 0,
            narration: "",
            amountCr: "",
        });
        setRowData([])
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "leaseNo") {
            const params = new URLSearchParams();
            params.append("Action", "GetRefundetailsByLeaseNo");
            params.append("LeaseNo", value?.label);
            const res = await apiService.getApiParamater("COMMON_BLNC_REF", `?${params.toString()}`);
            let data = res?.data?.result?.data
            const gridparams = new URLSearchParams();
            gridparams.append("Action", "GettenantAccountDetailsByLeaseNo");
            gridparams.append("LeaseNo", value?.label);
            const gridres = await apiService.getApiParamater("COMMON_BLNC_REF", `?${gridparams.toString()}`);
            let griddata = gridres?.data?.result?.data;

            let formattedData = [];

            if (Array.isArray(griddata)) {
                formattedData = griddata.map(item => ({
                    ...item,
                    debit: item?.debit ?? 0,
                }));
            } else if (griddata) {
                formattedData = [{
                    ...griddata,
                    debit: 0,
                }];
            }
            setRowData(formattedData);
            setFormData(prev => ({
                ...prev,
                [name]: value,
                balance: 0,
                amount: data?.BalanceLeaseAmount,
                tenantName: data?.Cust1_Name,
                tenantNo: data?.Cust1_No,
                property: data?.Property_Name,
                unitNo: data?.Unit_No,
                paidTo: griddata?.AccountName,
                amountCr: data?.Balance,
                fxAmount: data?.Balance
            }));
            setblncClr("text-success")
        } else if (name === "accountCr") {
            const params = new URLSearchParams();
            const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
            const activeFinancialYear = financialYears?.find(fy => fy.isActive);
            params.append("Action", "GetBalanceByCrAccountNo");
            params.append("TaxDescription", value?.value?.value);
            params.append("Agent", activeFinancialYear?.id);
            const res = await apiService.getApiParamater("COMMON_BLNC_REF", `?${params.toString()}`);
            let data = res?.data?.result?.data
            setFormData(prev => ({ ...prev, [name]: value, balance: data?.balance }));
            setblncClr("text-danger")
        } else if (name === "propertyType") {
            const params = new URLSearchParams();
            if (value?.label === "Other") {
                params.append("DropdownFor", "GetCrAccountNosByPyamentMethodOther");
            } else {
                params.append("DropdownFor", "GetCrAccountNosByPyamentMethod");
            }
            const res = await apiService.getApiParamater("CASCAD_BLNC_REF", `?${params.toString()}`);
            let data = res?.data?.items
            setFormData(prev => ({ ...prev, [name]: value, accountCr: null }));
            setAccountList(data)
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }

    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Ensure "DD-MMM-YYYY"
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    }
    // debit list
    const handleFieldChange = (index, field, value) => {
        const updated = [...rowData];
        if (field === "AccountCode") {
            updated[index][field] = value?.label;
            updated[index]['AccountName'] = value?.value;
            setRowData(updated);
        } else if (field === "AccountName") {
            updated[index][field] = value?.label;
            updated[index]['AccountCode'] = value?.value;
            setRowData(updated);
        } else {
            updated[index][field] = value;
            setRowData(updated);
        }
    };
    const handleAddRow = () => {
        setRowData(prev => ([
            ...prev,
            {
                AccountCode: "",
                AccountName: "",
                debit: 0,
            }
        ]));
    };
    const handleDeleteRow = (index) => {
        const updated = rowData.filter((_, i) => i !== index);
        setRowData(updated);
    };
    const HandleSave = async () => {
        setLoader(true)
        if (!formData.leaseNo.label) {
            toast.warning("Select Lease No");
            setLoader(false)
            return;
        }
        if (!formData.propertyType?.label) {
            toast.warning("Select Payment Type");
            setLoader(false)
            return;
        }
        if (
            formData.propertyType?.label === "Cheque" ||
            formData.propertyType?.label === "PDC"
        ) {
            // Cheque No required
            if (!formData.chequeNo || formData.chequeNo.trim() === "") {
                toast.warning("Cheque No is required");
                setLoader(false);
                return;
            }

            // Cheque Date required
            if (!formData.chequeDate) {
                toast.warning("Cheque Date is required");
                setLoader(false);
                return;
            }

            // Cheque Date must be greater than today
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const chequeDate = new Date(formData.chequeDate);
            chequeDate.setHours(0, 0, 0, 0);

            if (chequeDate <= today) {
                toast.warning("Cheque Date must be greater than today");
                setLoader(false);
                return;
            }
        }
        if (!formData?.accountCr?.label) {
            toast.warning("Select Credit Account");
            setLoader(false)
            return;
        }
        if (rowData.length === 0) {
            toast.warning("Please add Accounts");
            setLoader(false)
            return;
        }
        if (formData?.amountCr != total) {
            toast.warning("Debit Amount must b equal to Credit Amount");
            setLoader(false)
            return;
        }

        for (const item of rowData) {
            if (!item.AccountCode) {
                toast.warning(`Please Select Account`);
                setLoader(false);
                return;
            } else if (!item.debit) {
                toast.warning(`Please enter Debit Amount`);
                setLoader(false);
                return;
            }
        }
        try {
            const currentDatetimeUTC = new Date().toISOString();
            const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
            const activeFinancialYear = financialYears?.find(fy => fy.isActive);

            if (!activeFinancialYear) {
                toast.warning('No active financial year found');
                setLoader(false);
                return;
            }

            // Convert dates
            const voucherDate = new Date(formData?.voucherDate); // e.g. "22-Jan-2026"
            const yearFrom = new Date(activeFinancialYear.yearFrom);
            const yearTo = new Date(activeFinancialYear.yearTo);

            // Financial Year validation
            if (voucherDate < yearFrom || voucherDate > yearTo) {
                toast.warning('Voucher date is not within the active financial year');
                setLoader(false);
                return;
            } else {
                const debitLines = rowData.map((item, index) => {
                    return {
                        acCode: item?.AccountCode,
                        accountName: item?.AccountName,
                        amount: parseFloat(item?.debit),
                        narration: formData?.narration || "0",
                        costCenter1: formData?.property || "0",
                        costCenter2: formData?.unitNo || "0",
                    }
                });
                const body = {
                    leaseBalanceRefundRequest: {
                        voucherType: "Payment",
                        postingDate: moment(formData?.voucherDate || currentDatetimeUTC).format(),
                        refNo: formData?.refNo || "0",
                        acCode: formData?.accountCr?.value?.value || "0",
                        accountName: formData?.accountCr?.label || "0",
                        amount: parseFloat(formData?.amountCr),
                        currency: formData?.currency?.label || "0",
                        conversionRate: parseInt(formData?.conversionRate) || 0,
                        narration: formData?.narration || "0",
                        transactionMethod: formData?.propertyType?.label || "0",
                        createdBy: userName || "0",
                        leaseNo: formData?.leaseNo?.label,
                        tenantNo: formData?.tenantNo || "0",
                        tenantName: formData?.tenantName || "0",
                        paidTo: formData?.paidTo || "0",
                        costCenter1: formData?.property || "0",
                        costCenter2: formData?.unitNo || "0",
                        chequeNo: formData?.chequeNo || "0",
                        chequeDate: moment(formData?.chequeDate || "1900-01-01T09:33:21.434Z").format(),
                        drawnBank: "0",
                        invoiceNo: formData?.voucherNo || "0",
                        dueDate: "1900-01-01T09:33:21.434Z",
                        debitLines: debitLines
                    }
                };
                
                const response = await apiService.post("POST_BLNC_REF", body);

                if (response?.data?.statusCode === 201 || response?.data?.statusCode === 200) {
                    toast.success(response?.data?.message);
                    setLoader(false)
                    handleClearFilters()
                }
                setLoader(false);
            }
        } catch (error) {
            setLoader(false)
            console.error("Error Creating PR:", error);
        }
    };
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Lease No</label>
                                <WindowedSelect
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.leaseNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'leaseNo', value: selectedOption })}
                                    options={leaseList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">Voucher No</label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="voucherNo"
                                    disable
                                    value={formData.voucherNo}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div><label className="form-label pt-2 start">{formData?.property || "---"}</label></div>
                            <div className="d-flex">
                                <label className="form-label">Voucher Date</label>
                                <DatePicker
                                    selected={formData.voucherDate}
                                    onChange={(date) => handleDateChange({ name: 'voucherDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                                <label className="form-label center"><span className=" text-primary">Balance</span></label>
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">Ref No</label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="refNo"
                                    value={formData.refNo}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div><label className="form-label pt-2 start">{formData?.unitNo || "---"}</label></div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Payment Type</label>
                                <WindowedSelect
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.propertyType}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'propertyType', value: selectedOption })}
                                    options={propertyType?.map(country => ({ value: country, label: country?.text }))}
                                />
                                <label className="form-label center"><span className={blncclr}>{formData?.balance?.toFixed(currencyPrecision?.decimalNumbers || 2) || "0.000"}</span></label>
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">Cheque No</label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="chequeNo"
                                    value={formData.chequeNo}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div><label className="form-label pt-2 start">{formData?.tenantName || "---"}</label></div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Account (Cr)</label>
                                <WindowedSelect
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.accountCr}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'accountCr', value: selectedOption })}
                                    options={accountList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label w-0">Cheque Date</label>
                                <DatePicker
                                    selected={formData.chequeDate}
                                    onChange={(date) => handleDateChange({ name: 'chequeDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Currency</label>
                                <WindowedSelect
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.currency}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'currency', value: selectedOption })}
                                    options={currencyList?.map(country => ({ value: country, label: country?.code }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">Conversion Rate</label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="conversionRate"
                                    value={formData.conversionRate}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">Paid to</label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="paidTo"
                                    value={formData.paidTo}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">FX Amount</label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="fxAmount"
                                    value={formData.fxAmount}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">Narration</label>
                                <input
                                    type="text"
                                    className="form-control p-2 w-75"
                                    name="narration"
                                    value={formData.narration}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">Amount (Cr)</label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="amountCr"
                                    value={formData.amountCr}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="d-flex gap-1">
                                {loading === true ?
                                    <div className='mainbtn flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div className='mainbtn flex-end gap-2 w-50' onClick={HandleSave}>
                                        <FaSave color='#fff' className='center mt-2 mx-2' />
                                        <div className='center'>Save</div>
                                    </div>
                                }
                                <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2 w-50">
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-contant-between ">
                            <h5 className="col mainInvHead">Lease Balance Payment</h5>
                        </div>
                        <div className="border-box2 mt-2 p-1" style={{ borderRadius: '8px' }}>
                            <div className='table-container'>
                                <table className='table table-bordered gridshad'>
                                    <thead className='dynoTable'>
                                        <tr>
                                            <th>Action</th>
                                            <th>Account Code</th>
                                            <th>Account Name</th>
                                            <th>Debit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rowData.map((data, index) => (
                                            <tr key={index}>
                                                {/* Account Code */} {/* Delete */}
                                                <td className="text-center">
                                                    <button
                                                        className="btn btn-sm btn-danger"
                                                        onClick={() => handleDeleteRow(index)}
                                                    >
                                                        <MdDelete size={20} />
                                                    </button>
                                                </td>
                                                <td>
                                                    <WindowedSelect
                                                        className="p-0 w-100"
                                                        menuPortalTarget={document.body}
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        value={
                                                            data?.AccountCode
                                                                ? { label: data.AccountCode, value: data.AccountCode }
                                                                : null
                                                        }
                                                        onChange={(opt) =>
                                                            handleFieldChange(index, "AccountCode", opt)
                                                        }
                                                        options={debitList?.map(i => ({
                                                            value: i?.text,
                                                            label: i?.value,
                                                        }))}
                                                    />
                                                </td>

                                                {/* Account Name */}
                                                <td>
                                                    <WindowedSelect
                                                        className="p-0 w-100"
                                                        menuPortalTarget={document.body}
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        value={
                                                            data?.AccountName
                                                                ? { label: data.AccountName, value: data.AccountName }
                                                                : null
                                                        }
                                                        onChange={(opt) =>
                                                            handleFieldChange(index, "AccountName", opt)
                                                        }
                                                        options={debitList?.map(i => ({
                                                            value: i?.value,
                                                            label: i?.text,
                                                        }))}
                                                    />
                                                </td>

                                                {/* Debit (editable) */}
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control p-1"
                                                        value={data.debit}
                                                        onChange={(e) =>
                                                            handleFieldChange(index, "debit", Number(e.target.value))
                                                        }
                                                    />
                                                </td>


                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <button
                                className="btn btn-sm btn-primary my-2"
                                onClick={handleAddRow}
                            >
                                + Add Row
                            </button>
                            <div className='center boxs p-1' style={{ borderRadius: "8px" }}>
                                <div className='d-flex gap-2 '>
                                    <div className="totalhead center">Total</div>
                                    <div className='field'>{total?.toFixed(currencyPrecision?.decimalNumbers || 2) || "---"}</div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default LeaseBalancePayment;
